const requestAccessControlConfirmation = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: [],
    cc: [],
    subject: `Access Control Request Received On ops portal`,
    html: `
          <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Access Control Request Received On ops portal</title>
        <style>
            body {
                font-family: Arial, sans-serif;
                background-color: #f2f2f2;
                margin: 0;
                padding: 20px;
            }
            .container {
                max-width: 600px;
                margin: 0 auto;
                background-color: #ffffff;
                padding: 20px;
                border-radius: 10px;
                box-shadow: 0 0 10px rgba(0,0,0,0.1);
            }
            .header {
                text-align: center;
                margin-bottom: 20px;
            }
            .header img {
                max-width: 100px;
                margin-bottom: 20px;
            }
            .header h3 {
                color: #333;
                margin: 0;
            }
            .content p {
                font-size: 16px;
                line-height: 1.6;
                color: #555;
            }
            .content p strong {
                color: #333;
            }
            .footer p {
                font-size: 14px;
                line-height: 1.4;
                color: #999;
                text-align: center;
                margin: 20px 0 0;
            }
        </style>
    </head>
    <body>

        <div class="container">
            <div class="header">
                <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                <h3>Access Control Request Received On ops portal</h3>
            </div>
            <div class="content">
                <p>Dear <strong>${data.userName}</strong>,</p>
                <p>Thank you for submitting your access control request. We have received your request and it is currently being processed by operations team.</p>
                <p>You will receive another email once your request has been approved or rejected. Please feel free to contact us if you have any questions or concerns.</p>
                <p>Best regards,<br>Conga Operations Team</p>
            </div>
            <div class="footer">
                <p>&copy; ${new Date().getFullYear()} Conga (OPS PORTAL). All rights reserved.</p>
                <p>This portal is only for internal use. Please don't share any information of ops portal to a external user.</p>
            </div>
        </div>

    </body>
    </html>
        `
  };
};
const modifyAccessControlConfirmation = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: [],
    cc: [],
    subject: `Modification Request Received On ops portal`,
    html: `
          <!DOCTYPE html>
    <html lang="en">
    <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Modification Request Received On ops portal</title>
        <style>
            body {
                font-family: Arial, sans-serif;
                background-color: #f2f2f2;
                margin: 0;
                padding: 20px;
            }
            .container {
                max-width: 600px;
                margin: 0 auto;
                background-color: #ffffff;
                padding: 20px;
                border-radius: 10px;
                box-shadow: 0 0 10px rgba(0,0,0,0.1);
            }
            .header {
                text-align: center;
                margin-bottom: 20px;
            }
            .header img {
                max-width: 100px;
                margin-bottom: 20px;
            }
            .header h3 {
                color: #333;
                margin: 0;
            }
            .content p {
                font-size: 16px;
                line-height: 1.6;
                color: #555;
            }
            .content p strong {
                color: #333;
            }
            .footer p {
                font-size: 14px;
                line-height: 1.4;
                color: #999;
                text-align: center;
                margin: 20px 0 0;
            }
        </style>
    </head>
    <body>

        <div class="container">
            <div class="header">
                <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                <h3>Modification Request Received On ops portal</h3>
            </div>
            <div class="content">
                <p>Dear <strong>${data.userName}</strong>,</p>
                <p>Thank you for submitting your modification request for access control. Your request is being processed by the Operations team.</p>
                <p>You will receive another email once your request has been reviewed and processed. Please feel free to contact us if you have any questions or concerns.</p>
                <p>Best regards,<br>Conga Operations Team</p>
            </div>
            <div class="footer">
                <p>&copy; ${new Date().getFullYear()} Conga (OPS PORTAL). All rights reserved.</p>
                <p>This portal is only for internal use. Please don't share any information of ops portal to a external user.</p>
            </div>
        </div>

    </body>
    </html>
        `
  };
};

const requestAccessControlNotificationToCloudopsTeam = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: ['Cloud-Ops-All-DL@conga.com'], // Add the recipient email addresses here
    subject: `Reminder: Access Control Request Received on OPS Portal`,
    cc: [],
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Reminder: Access Control Request Received on OPS Portal</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Reminder: Access Control Request Received on OPS Portal</h3>
                </div>
                <div class="content">
                    <p>Dear Operations Team,</p>
                    <p>This is a reminder that an access control request has been submitted by <strong>${
                      data.userName
                    }</strong>.</p>
                    <p>Please review and process the request as soon as possible. You can view all requested access control details by clicking the link below:</p>
                    <p><a href="https://ops-portal.congacloud.com/#/cloudops-portal/access-requests">View Access Control Requests</a></p>
                    <p>Best regards,<br>Conga Operations Team</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga (OPS PORTAL). All rights reserved.</p>
                    <p>This portal is only for internal use. Please don't share any information of the OPS portal with external users.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

const notifyCloudopsTeamForModifiedRequest = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: ['Cloud-Ops-All-DL@conga.com'], // Add the recipient email addresses here
    subject: `Action Required: Modified Access Control Request on OPS Portal`,
    cc: [],
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Action Required: Modified Access Control Request on OPS Portal</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Action Required: Modified Access Control Request on OPS Portal</h3>
                </div>
                <div class="content">
                    <p>Dear Operations Team,</p>
                    <p>A modified access control request has been submitted by <strong>${
                      data.userName
                    }</strong>.</p>
                    <p>Please review and process the updated request as soon as possible. You can view all modified access control details by clicking the link below:</p>
                    <p><a href="https://ops-portal.congacloud.com/#/cloudops-portal/access-requests">View Access Control Requests</a></p>
                    <p>Best regards,<br>Conga Operations Team</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga (OPS PORTAL). All rights reserved.</p>
                    <p>This portal is only for internal use. Please don't share any information from the OPS portal with external users.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

const appliedAccessControlNotificationToUser = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: [], // The email of the user who applied for access control
    subject: `Access Control Granted on OPS Portal`,
    cc: [],
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Access Control Granted on OPS Portal</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Access Control Granted on OPS Portal</h3>
                </div>
                <div class="content">
                    <p>Dear <strong>${data.userName}</strong>,</p>
                    <p>We are pleased to inform you that your access control request has been approved. You now have access to the requested resources on the OPS portal.</p>
                    <p>If you have any questions or need further assistance, please feel free to contact us.</p>
                    <p>Best regards,<br>Conga Operations Team</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga (OPS PORTAL). All rights reserved.</p>
                    <p>This portal is only for internal use. Please don't share any information of the OPS portal with external users.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

const rejectedAccessControlNotificationToUser = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: [], // The email of the user who applied for access control
    subject: `Access Control Request Rejected on OPS Portal`,
    cc: [],
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Access Control Request Rejected on OPS Portal</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Access Control Request Rejected on OPS Portal</h3>
                </div>
                <div class="content">
                    <p>Dear <strong>${data.userName}</strong>,</p>
                    <p>We regret to inform you that your access control request has been rejected. Unfortunately, you will not have access to the requested resources on the OPS portal at this time.</p>
                    <p>If you have any questions or need further assistance, please feel free to contact us.</p>
                    <p>Best regards,<br>Conga Operations Team</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga (OPS PORTAL). All rights reserved.</p>
                    <p>This portal is only for internal use. Please don't share any information of the OPS portal with external users.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

const accessControlModifiedNotificationToUser = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: [], // Email of the user whose access control was modified
    subject: `Access Control Updated on OPS Portal`,
    cc: [],
    html: `
          <!DOCTYPE html>
          <html lang="en">
          <head>
              <meta charset="UTF-8">
              <meta name="viewport" content="width=device-width, initial-scale=1.0">
              <title>Access Control Updated on OPS Portal</title>
              <style>
                  body {
                      font-family: Arial, sans-serif;
                      background-color: #f2f2f2;
                      margin: 0;
                      padding: 20px;
                  }
                  .container {
                      max-width: 600px;
                      margin: 0 auto;
                      background-color: #ffffff;
                      padding: 20px;
                      border-radius: 10px;
                      box-shadow: 0 0 10px rgba(0,0,0,0.1);
                  }
                  .header {
                      text-align: center;
                      margin-bottom: 20px;
                  }
                  .header img {
                      max-width: 100px;
                      margin-bottom: 20px;
                  }
                  .header h3 {
                      color: #333;
                      margin: 0;
                  }
                  .content p {
                      font-size: 16px;
                      line-height: 1.6;
                      color: #555;
                  }
                  .content p strong {
                      color: #333;
                  }
                  .footer p {
                      font-size: 14px;
                      line-height: 1.4;
                      color: #999;
                      text-align: center;
                      margin: 20px 0 0;
                  }
              </style>
          </head>
          <body>
    
              <div class="container">
                  <div class="header">
                      <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                      <h3>Access Control Updated on OPS Portal</h3>
                  </div>
                  <div class="content">
                      <p>Dear <strong>${data.userName}</strong>,</p>
                      <p>We would like to inform you that your access control settings have been updated on the OPS portal. Please review the changes to ensure they meet your needs.</p>
                      <p>If you have any questions or need further assistance, please feel free to contact us.</p>
                      <p>Best regards,<br>Conga Operations Team</p>
                  </div>
                  <div class="footer">
                      <p>&copy; ${new Date().getFullYear()} Conga (OPS PORTAL). All rights reserved.</p>
                      <p>This portal is only for internal use. Please don't share any information of the OPS portal with external users.</p>
                  </div>
              </div>
    
          </body>
          </html>
        `
  };
};

const reminderToUsePlatformOrg = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: [data.adminUserEmail], // Add the recipient email addresses here
    cc: ['Cloud-Ops-All-DL@conga.com', 'anishetty@conga.com'],
    subject: `Reminder: Your Conga Platform Organization is Inactive`,
    html: `<!DOCTYPE html>
  <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <title>Reminder: Your Conga Platform Organization is Inactive</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          background-color: #f2f2f2;
          margin: 0;
          padding: 20px;
        }
        .container {
          max-width: 600px;
          margin: 0 auto;
          background-color: #ffffff;
          padding: 20px;
          border-radius: 10px;
          box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
        }
        .header {
          text-align: center;
          margin-bottom: 20px;
        }
        .header img {
          max-width: 100px;
          margin-bottom: 20px;
        }
        .header h3 {
          color: #333;
          margin: 0;
        }
        .content p {
          font-size: 16px;
          line-height: 1.6;
          color: #555;
        }
        .content p strong {
          color: #333;
        }
        .button {
          display: inline-block;
          padding: 10px 20px;
          margin-top: 20px;
          font-size: 16px;
          color: #fff;
          background-color: #007bff;
          text-decoration: none;
          border-radius: 5px;
        }
        .details {
          margin-top: 20px;
          padding: 10px;
          background-color: #f9f9f9;
          border-radius: 5px;
        }
        .details p {
          margin: 5px 0;
          font-size: 14px;
          color: #333;
        }
        .footer p {
          font-size: 14px;
          line-height: 1.4;
          color: #999;
          text-align: center;
          margin: 20px 0 0;
        }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <img
            src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg"
            alt="Conga Logo"
          />
          <h3>Reminder: Your Conga Platform Organization is Inactive</h3>
        </div>
        <div class="content">
          <p>Dear <strong>${data.adminUserName}</strong>,</p>
          <p>
            We have noticed that your organization on the Conga platform has been
            inactive for the past six months. To keep your organization active,
            please log in to your account.
          </p>
          <div class="details">
            <p><strong>Organization Details:</strong></p>
            <p>Org ID: ${data.orgId}</p>
            <p>Org Friendly ID: ${data.orgFriendlyId}</p>
            <p>Customer ID: ${data.customerId}</p>
            <p>Platform Environment Name: ${data.environmentName}</p>
            <p><strong>Admin Information:</strong></p>
            <p>User ID: ${data.adminUserId}</p>
            <p>User Name: ${data.adminUserName}</p>
            <p>User Email: ${data.adminUserEmail}</p>
          </div>
          <a href="${data.loginUrl}" class="button"
            >Login to Conga Platform Org</a
          >
          <p>
            If no login activity is detected within the next month, your
            organization may be subject to inactivation and subsequent
            termination.
          </p>
          <p>
            If you have any questions or need further assistance, please feel free
            to contact us at Cloud-Ops-All-DL@conga.com
          </p>
          <p>Best regards,<br />Conga Operations Team</p>
        </div>
        <div class="footer">
          <p>
            &copy; ${new Date().getFullYear()} Conga Platform. All rights
            reserved.
          </p>
          <p>
            This notification is intended for the recipient's internal use only.
            Please do not share this information with external parties.
          </p>
        </div>
      </div>
    </body>
  </html>
  `
  };
};

const xAuthorUpdateNotification = (data) => {
  return {
    from: data.from || `ops-portal@conga.com`,
    to: [],
    cc: [],
    subject: `Important Update: Unifying Login Systems & X-Author Update`,
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Important Update: Unifying Login Systems & X-Author Update</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
                a {
                    color: #007BFF;
                    text-decoration: none;
                }
                a:hover {
                    text-decoration: underline;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Important Update: Unifying Login Systems & X-Author Update</h3>
                </div>
                <div class="content">
                    <p>Dear <strong>${data.customerName}</strong>,</p>
                    <p>We appreciate you as one of our valued customers. We are excited to announce an upcoming update aimed at unifying the login systems for both Preview and Production users, making it easier to access your details across environments.</p>
                    <p>If you do not use the <strong>“X-Author for Contracts Advanced”</strong> application, or if you are only using the <strong>“X-Author for Contracts” Advanced (Prod)</strong> add-in, you can ignore this message.</p>
                    <p>However, if you use the <strong>“X-Author for Contracts” Advanced (Preview)</strong> add-in, please update your app manifest file to the latest version by following the instructions here: 
                    <a href="https://community.conga.com/s/article/X-Author-for-Contracts-Advanced-Updating-the-Manifest-File-when-Using-Centralized-Deployment" target="_blank">X-Author for Contracts Advanced: Updating the Manifest File when Using Centralized Deployment</a>.</p>
                    <p>This update is scheduled for release tentatively on <strong>11 May 2025</strong>. To avoid login issues and ensure a smooth experience, please install the latest X-Author file by <strong>May 10, 2025</strong>.</p>
                    <p>If you have questions, reach out to your Conga team, which you can find in the <strong>My Account</strong> space of the Conga Customer Community.</p>
                    <p>Best regards,<br>Conga Team</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

const cpqTrustedUrlsUpdateNotification = (data) => {
  return {
    from: data.from || `ops-portal@conga.com`,
    to: [],
    cc: [],
    subject: `Important Update: Unifying Login Systems & Update Trusted URLs for CPQ on Salesforce`,
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Important Update: Unifying Login Systems & Update Trusted URLs for CPQ on Salesforce</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
                a {
                    color: #007BFF;
                    text-decoration: none;
                }
                a:hover {
                    text-decoration: underline;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Important Update: Unifying Login Systems & Update Trusted URLs for CPQ on Salesforce</h3>
                </div>
                <div class="content">
                    <p>Dear <strong>${data.customerName}</strong>,</p>
                    <p>We appreciate you as one of our valued customers. We are excited to announce an upcoming update aimed at unifying the login systems for both Preview and Production users, making it easier to access your details across environments.</p>
                    <p>If you do not launch the <strong>“CPQ UI”</strong> application to configure the proposal from the Salesforce Proposal page, or if you are using it only for the Production environment, you can ignore this message.</p>
                    <p>However, if you launch the <strong>“CPQ UI”</strong>  application to configure the proposal from the Salesforce proposal page in the Preview environment, please update your Trusted URLs on Salesforce by following the instructions in the document linked here: 
                    <a href="https://documentation.conga.com/en/advantage-platform-administration/current/conga-advantage-platform-for-administrators/adding-trusted-urls-for-salesforce-integration" target="_blank">Updating Trusted URLs for CPQ</a>.</p>
                    <p>This update is scheduled for release tentatively on <strong>11 May 2025</strong>. To avoid login issues and ensure a smooth experience, please update the Trusted URLs by <strong>May 10, 2025</strong>.</p>
                    <p>If you have questions, reach out to your Conga team, which you can find in the <strong>My Account</strong> space of the Conga Customer Community.</p>
                    <p>Best regards,<br>Conga Team</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

const guestUserIdUpdateNotification = (data) => {
  return {
    from: data.from || `ops-portal@conga.com`,
    to: [],
    cc: [],
    subject: `Important Update: Unifying Login Systems & Guest User ID Update Needed`,
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Important Update: Unifying Login Systems & Guest User ID Update Needed</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
                ol {
                    margin: 10px 0;
                    padding-left: 20px;
                }
                li {
                    margin-bottom: 8px;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Important Update: Unifying Login Systems & Guest User ID Update Needed</h3>
                </div>
                <div class="content">
                    <p>Dear <strong>${data.customerName}</strong>,</p>
                    <p>We appreciate you as one of our valued customers. We are excited to announce an upcoming update aimed at unifying the login systems for both Preview and Production users, making it easier to access your details across environments.</p>
                    <p>In the process of unifying these login systems, a duplicate guest user ID has been identified in both your Preview and Production environments.</p>
  
                    <p><strong>Guest User ID:</strong> 49237edc-1b4a-504c-d5d0-718067c486e3</p>
                    <p><strong>Preview Org ID:</strong> 97b67465-a185-4131-bf5b-e0f3f29dc282 (Org Name - auiub0000000bzloam)</p>
                    <p><strong>Production Org ID:</strong> be3c79e9-b8db-4743-9d71-9b9aa03f47a1 (Org Name - hitachi-prod)</p>
  
                    <p>To avoid losing any information and to keep your preview storefront accessible in the future, please follow these steps to create a new Guest User for Preview:</p>
                    
                    <ol>
                        <li>Open the preview storefront URL for the Hitachi Energy EU.</li>
                        <li>Open the browser inspector panel, go to the Application tab, and check the storage section.</li>
                        <li>Look for the “userId” information in the local storage.</li>
                        <li>Check whether the same guest user ID – “49237edc-1b4a-504c-d5d0-718067c486e3” is already present.<br/>
                            If yes, proceed to create a new guest user.
                        </li>
                        <li>Create a new guest user with the same permissions as the existing one (“49237edc-1b4a-504c-d5d0-718067c486e3”).</li>
                        <li>After creating the new guest user, copy the new guest user ID.</li>
                        <li>Update the configuration file (<strong>environment.ts</strong>) at the ecommerce template level with the new guest user ID for the DC application. You need to update the <strong>“userId”</strong> field in the configuration.</li>
                        <li>Once the new guest user ID is configured, proceed to generate a build using the updated guest user.</li>
                    </ol>
  
                    <p>This update is scheduled for release tentatively on <strong>11 May 2025</strong>. To avoid access issues and ensure a smooth experience, please update the Guest User ID as suggested by <strong>May 10, 2025</strong>.</p>
  
                    <p>If you have questions, reach out to your Conga team, which you can find in the <strong>My Account</strong> space of the Conga Customer Community.</p>
  
                    <p>Best regards,<br>Conga Team</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

const notifyApproversForChangeRequest = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: data.approversEmails, // List of approvers' email addresses
    subject: `Approval Required: Feature Flag Change Request`,
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Approval Required: Feature Flag Change Request</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
                a.button {
                    display: inline-block;
                    margin-top: 15px;
                    padding: 10px 20px;
                    background-color: #007BFF;
                    color: #ffffff !important;
                    text-decoration: none;
                    border-radius: 5px;
                    font-weight: bold;
                }
            </style>
        </head>
        <body>
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Approval Required: Feature Flag Change Request</h3>
                </div>
                <div class="content">
                    <p>Dear Approver,</p>
                    <p>A change request has been submitted for the feature flag <strong>${
                      data.flagName
                    }</strong>.</p>
                    <p><strong>Requested by:</strong> ${data.requestedBy}</p>
                    <p><strong>Environment:</strong> ${data.environment}</p>
                    <p>Please review and take appropriate action using the button below:</p>
                    <p><a href="${
                      data.approvalLink
                    }" class="button" target="_blank">Review Change Request</a></p>
                    <p>Best regards,<br>Conga Operations Team</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
                </div>
            </div>
        </body>
        </html>
      `
  };
};

const notifyRequesterChangeApproved = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: [data.requestedByEmail],
    subject: `Approved: Feature Flag Change Request (${data.flagName})`,
    html: `
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Change Request Approved</title>
          <style>
              body {
                  font-family: Arial, sans-serif;
                  background-color: #f2f2f2;
                  margin: 0;
                  padding: 20px;
              }
              .container {
                  max-width: 600px;
                  margin: 0 auto;
                  background-color: #ffffff;
                  padding: 20px;
                  border-radius: 10px;
                  box-shadow: 0 0 10px rgba(0,0,0,0.1);
              }
              .header {
                  text-align: center;
                  margin-bottom: 20px;
              }
              .header img {
                  max-width: 100px;
                  margin-bottom: 20px;
              }
              .header h3 {
                  color: #333;
                  margin: 0;
              }
              .content p {
                  font-size: 16px;
                  line-height: 1.6;
                  color: #555;
              }
              .content p strong {
                  color: #333;
              }
              .footer p {
                  font-size: 14px;
                  line-height: 1.4;
                  color: #999;
                  text-align: center;
                  margin: 20px 0 0;
              }
          </style>
      </head>
      <body>
          <div class="container">
              <div class="header">
                  <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                  <h3>Change Request Approved</h3>
              </div>
              <div class="content">
                  <p>Dear <strong>${data.requestedBy}</strong>,</p>
                  <p>Your request to update the feature flag <strong>${
                    data.flagName
                  }</strong> in the <strong>${
      data.environment
    }</strong> environment has been <strong>approved</strong>.</p>
                  <p>Best regards,<br>Conga Operations Team</p>
              </div>
              <div class="footer">
                  <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
              </div>
          </div>
      </body>
      </html>
      `
  };
};

const notifyRequesterChangeRejected = (data) => {
  return {
    from: `ops-portal@conga.com`,
    to: [data.requestedByEmail],
    subject: `Rejected: Feature Flag Change Request (${data.flagName})`,
    html: `
      <!DOCTYPE html>
      <html lang="en">
      <head>
          <meta charset="UTF-8">
          <meta name="viewport" content="width=device-width, initial-scale=1.0">
          <title>Change Request Rejected</title>
          <style>
              body {
                  font-family: Arial, sans-serif;
                  background-color: #f2f2f2;
                  margin: 0;
                  padding: 20px;
              }
              .container {
                  max-width: 600px;
                  margin: 0 auto;
                  background-color: #ffffff;
                  padding: 20px;
                  border-radius: 10px;
                  box-shadow: 0 0 10px rgba(0,0,0,0.1);
              }
              .header {
                  text-align: center;
                  margin-bottom: 20px;
              }
              .header img {
                  max-width: 100px;
                  margin-bottom: 20px;
              }
              .header h3 {
                  color: #333;
                  margin: 0;
              }
              .content p {
                  font-size: 16px;
                  line-height: 1.6;
                  color: #555;
              }
              .content p strong {
                  color: #333;
              }
              .footer p {
                  font-size: 14px;
                  line-height: 1.4;
                  color: #999;
                  text-align: center;
                  margin: 20px 0 0;
              }
          </style>
      </head>
      <body>
          <div class="container">
              <div class="header">
                  <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                  <h3>Change Request Rejected</h3>
              </div>
              <div class="content">
                  <p>Dear <strong>${data.requestedBy}</strong>,</p>
                  <p>Your request to update the feature flag <strong>${
                    data.flagName
                  }</strong> in the <strong>${
      data.environment
    }</strong> environment has been <strong>rejected</strong>.</p>
                  ${
                    data.rejectionReason
                      ? `<p><strong>Reason:</strong> ${data.rejectionReason}</p>`
                      : ''
                  }
                  <p>If you have any questions, feel free to reach out to the Operations team.</p>
                  <p>Best regards,<br>Conga Operations Team</p>
              </div>
              <div class="footer">
                  <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
              </div>
          </div>
      </body>
      </html>
      `
  };
};

// New email template for Salesforce User ID conflict notification
const salesforceUserIdConflictNotification = (data) => {
  return {
    from: data.from || `ops-portal@conga.com`,
    to: [],
    cc: [],
    subject: `Important Update: Unifying Login Systems`,
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Important Update: Unifying Login Systems</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
                a {
                    color: #007BFF;
                    text-decoration: none;
                }
                a:hover {
                    text-decoration: underline;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Important Update: Unifying Login Systems</h3>
                </div>
                <div class="content">
                    <p>Dear <strong>${data.customerName}</strong>,</p>
                    <p>We appreciate you as one of our valued customers. We are excited to announce an upcoming update aimed at unifying the login systems for both Preview and Production users, making it easier to access your details across environments. This update is scheduled on <strong>8th June 2025</strong>.</p>
                    
                    <p>We see that only for your account, there is a user created on production, as well as a preview with the same Salesforce User Id and Salesforce Organization.</p>
                    
                    <p><strong>Username:</strong> ${
                      data.username || 'sreehari.geda1.is@schwab.com.perseus'
                    }</p>
                    <p><strong>Email:</strong> ${
                      data.email || 'sreehari.geda1@schwab.com'
                    }</p>
                    <p><strong>Preview org ID:</strong> ${
                      data.previewOrgId ||
                      '37bafa0c-8f6b-472f-8842-5e5ea1b7e319'
                    }</p>
                    
                    <p>In the update scheduled, we will have to resolve this conflict by keeping the production account for this user intact. However, the preview account and associated data for this user will be disabled (as only 1X1 mapping is supported for Salesforce to Conga tenant). We request you to create a new User for the preview tenant.</p>
                    
                    <p>If you have questions, reach out to your Conga team, which you can find in the <a href="https://community.conga.com/s/comm-my-account" target="_blank">My Account</a> space of the <a href="https://community.conga.com/s/welcome" target="_blank">Conga Customer Community</a>.</p>
                    
                    <p>Regards,<br>Team Conga</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

// New email template for SAML Apps login URL update notification
const samlAppsUpdateNotification = (data) => {
  // Ensure we have proper defaults for attachments to prevent type errors
  const defaultAttachments = [
    {
      filename:
        'SAML SSO - Changes required after Conga ID Update (Preview + Production).pdf',
      path: '/attachments/SAML SSO - Changes required after Conga ID Update (Preview + Production).pdf',
      contentType: 'application/pdf',
      type: 'application/pdf', // Ensuring type is defined
      content: null
    }
  ];

  // Ensure data.attachments has required properties
  const attachments =
    Array.isArray(data.attachments) && data.attachments.length > 0
      ? data.attachments.map((att) => ({
          ...att,
          type: att.type || att.contentType || 'application/pdf',
          content: att.content || null
        }))
      : defaultAttachments;

  return {
    from: data.from || `ops-portal@conga.com`,
    to: [],
    cc: [],
    subject: `Important Update: Unifying Login Systems – Update needed on login URL in SAML Apps`,
    attachments,
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Important Update: Unifying Login Systems – Update needed on login URL in SAML Apps</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 100px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #555;
                }
                .content p strong {
                    color: #333;
                }
                .attachment {
                    margin-top: 20px;
                    padding: 15px;
                    background-color: #f9f9f9;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                }
                .attachment-title {
                    margin-top: 0;
                    margin-bottom: 15px;
                    color: #333;
                    font-size: 18px;
                    font-weight: bold;
                }
                .attachment-content {
                    overflow-x: auto;
                }
                .url-table {
                    width: 100%;
                    border-collapse: collapse;
                    font-size: 14px;
                }
                .url-table th, .url-table td {
                    padding: 8px 12px;
                    border: 1px solid #ddd;
                    text-align: left;
                }
                .url-table th {
                    background-color: #f2f2f2;
                    color: #333;
                }
                .url-table tr:nth-child(even) {
                    background-color: #f9f9f9;
                }
                .note {
                    margin-top: 15px;
                    font-style: italic;
                    color: #666;
                }
                .footer p {
                    font-size: 14px;
                    line-height: 1.4;
                    color: #999;
                    text-align: center;
                    margin: 20px 0 0;
                }
                a {
                    color: #007BFF;
                    text-decoration: none;
                }
                a:hover {
                    text-decoration: underline;
                }
            </style>
        </head>
        <body>
  
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Important Update: Unifying Login Systems – Update needed on login URL in SAML Apps</h3>
                </div>
                <div class="content">
                    <p>Dear <strong>${data.customerName}</strong>,</p>
                    <p>We appreciate you as one of our valued customers. We are excited to announce an upcoming update aimed at unifying the login systems for both Preview and Production users, making it easier to access your details across environments. This update is scheduled on <strong>8th June 2025</strong>.</p>
                    
                    <p>As a result of this update, the SAML Service Provider metadata for Preview would be deprecated. Customers will be able to use the Production Service Provider metadata for Preview as well as Production organizations. So, please edit your existing Preview application (on the IDP) to point the relevant URLs (e.g. ACS URL, Entity ID, SLO URL) to Production. This should hardly take a few minutes, so please do it on <strong>9th June 2025</strong> to ensure uninterrupted access.</p>
    
                    <p>If you have questions, reach out to your Conga team, which you can find in the <a href="https://community.conga.com/s/comm-my-account" target="_blank">My Account</a> space of the <a href="https://community.conga.com/s/welcome" target="_blank">Conga Customer Community</a>.</p>
                    
                    <p>Regards,<br>Team Conga</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

// New email template for SAML Apps user assignment notification
const samlAppsUserAssignmentNotification = (data) => {
  // Ensure we have proper defaults for attachments to prevent type errors
  const defaultAttachments = [
    {
      filename:
        'SAML SSO - Changes required after Conga ID Update (Preview).pdf',
      path: '/attachments/SAML SSO - Changes required after Conga ID Update (Preview).pdf',
      contentType: 'application/pdf',
      type: 'application/pdf', // Ensuring type is defined
      content: null
    }
  ];

  // Ensure data.attachments has required properties
  const attachments =
    Array.isArray(data.attachments) && data.attachments.length > 0
      ? data.attachments.map((att) => ({
          ...att,
          type: att.type || att.contentType || 'application/pdf',
          content: att.content || null
        }))
      : defaultAttachments;

  return {
    from: data.from || `ops-portal@conga.com`,
    to: [],
    cc: [],
    subject: `Important Update: Unifying Login Systems – Assign users to Prod Apps`,
    attachments,
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>Important Update: Unifying Login Systems – Assign users to Prod Apps</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 600px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                }
                .header img {
                    max-width: 200px;
                    margin-bottom: 20px;
                }
                .header h3 {
                    color: #333;
                    margin: 0;
                    line-height: 1.4;
                }
                .content {
                    padding: 20px 0;
                }
                .content p {
                    margin-bottom: 15px;
                    line-height: 1.6;
                }
                .footer {
                    text-align: center;
                    color: #777;
                    font-size: 12px;
                    margin-top: 20px;
                    border-top: 1px solid #eee;
                    padding-top: 20px;
                }
                .attachment {
                    background-color: #f9f9f9;
                    border-left: 4px solid #007bff;
                    margin: 20px 0;
                    padding: 15px;
                    border-radius: 4px;
                }
                .attachment-title {
                    color: #333;
                    margin-top: 0;
                    font-size: 16px;
                }
                .attachment-content {
                    color: #555;
                    font-size: 14px;
                }
                .note {
                    font-style: italic;
                    color: #666;
                    font-size: 13px;
                }
                a {
                    color: #007bff;
                    text-decoration: none;
                }
                a:hover {
                    text-decoration: underline;
                }
                strong {
                    font-weight: bold;
                }
                .action-needed {
                    background-color: #fffbea;
                    border-left: 4px solid #ffc107;
                    padding: 15px;
                    margin: 20px 0;
                    border-radius: 4px;
                }
                .action-needed h4 {
                    margin-top: 0;
                    color: #856404;
                }
            </style>
        </head>
        <body>
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h3>Important Update: Unifying Login Systems – Assign users to Prod Apps</h3>
                </div>
                <div class="content">
                    <p>Dear <strong>${data.customerName}</strong>,</p>
                    <p>We appreciate you as one of our valued customers. We are excited to announce an upcoming update aimed at unifying the login systems for both Preview and Production users, making it easier to access your details across environments. This update is scheduled on <strong>8th June 2025</strong>.</p>
                    
                    <div class="action-needed">
                        <h4>Action Required Before 8th June 2025</h4>
                        <p>After this update, all your SAML users on Preview environment will be directing to the Production application. Moving forward, maintaining two different applications for Preview and Production will not be necessary.</p>
                        <p><strong>To ensure uninterrupted access</strong> to all your users, kindly ensure that all your current Preview IDP App users are assigned access to the Production IDP App as well before 8th June 2025.</p>
                    </div>
                    
                    <p>If you have questions, reach out to your Conga team, which you can find in the <a href="https://community.conga.com/s/comm-my-account" target="_blank">My Account</a> space of the <a href="https://community.conga.com/s/welcome" target="_blank">Conga Customer Community</a>.</p>
                    
                    <p>Regards,<br>Team Conga</p>
                </div>
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
                </div>
            </div>
  
        </body>
        </html>
      `
  };
};

// New email template for MongoDB Weekly Maintenance notification
const mongoDBWeeklyMaintenanceNotification = (data) => {
  return {
    from: data.from || `ops-portal@conga.com`,
    to: data.to || [],
    cc: data.cc || ['Cloud-Ops-All-DL@conga.com'],
    subject: `CloudOps Weekly Infra Maintenance and Reboot Activity for Turbo Non Production Database MongoDB servers`,
    html: `
        <!DOCTYPE html>
        <html lang="en">
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <title>CloudOps Weekly MongoDB Maintenance Notification</title>
            <style>
                body {
                    font-family: Arial, sans-serif;
                    background-color: #f2f2f2;
                    margin: 0;
                    padding: 20px;
                }
                .container {
                    max-width: 800px;
                    margin: 0 auto;
                    background-color: #ffffff;
                    padding: 20px;
                    border-radius: 10px;
                    box-shadow: 0 0 10px rgba(0,0,0,0.1);
                }
                .header {
                    text-align: center;
                    margin-bottom: 20px;
                    padding-bottom: 15px;
                    border-bottom: 2px solid #f2f2f2;
                }
                .header img {
                    max-width: 150px;
                    margin-bottom: 15px;
                }
                .header h2 {
                    color: #333;
                    margin: 0;
                    font-size: 24px;
                }
                .section {
                    margin-bottom: 25px;
                }
                .section h3 {
                    color: #00668c;
                    border-bottom: 1px solid #ddd;
                    padding-bottom: 8px;
                    margin-bottom: 15px;
                    font-size: 18px;
                }
                .content p {
                    font-size: 16px;
                    line-height: 1.6;
                    color: #444;
                }
                .tenant-list {
                    background-color: #f9f9f9;
                    padding: 15px;
                    border-left: 4px solid #00668c;
                    margin: 15px 0;
                    border-radius: 4px;
                    line-height: 1.4;
                }
                .tenant {
                    margin-bottom: 20px;
                    padding-bottom: 15px;
                    border-bottom: 1px solid #eee;
                }
                .tenant:last-child {
                    margin-bottom: 0;
                    padding-bottom: 0;
                    border-bottom: none;
                }
                .tenant h4 {
                    margin-top: 0;
                    margin-bottom: 8px;
                    color: #333;
                }
                .tenant-names {
                    font-family: monospace;
                    background-color: #f2f2f2;
                    padding: 10px;
                    border-radius: 4px;
                    line-height: 1.6;
                    word-break: break-word;
                }
                .impact {
                    margin-top: 10px;
                    font-weight: bold;
                    color: #d14836;
                }
                .schedule {
                    background-color: #fff8e1;
                    padding: 15px;
                    border-left: 4px solid #ffc107;
                    margin: 15px 0;
                    border-radius: 4px;
                }
                .schedule strong {
                    color: #e65100;
                }
                .help-section {
                    background-color: #e8f4fd;
                    padding: 15px;
                    border-left: 4px solid #2196f3;
                    margin: 15px 0;
                    border-radius: 4px;
                }
                .help-section a {
                    color: #0d6efd;
                    text-decoration: none;
                    font-weight: bold;
                }
                .help-section a:hover {
                    text-decoration: underline;
                }
                .additional-operations {
                    background-color: #f9e9e9;
                    padding: 15px;
                    border-left: 4px solid #d32f2f;
                    margin: 15px 0;
                    border-radius: 4px;
                }
                .additional-operations h4 {
                    color: #d32f2f;
                    margin-top: 0;
                    margin-bottom: 10px;
                    font-size: 16px;
                }
                .additional-operations-content {
                    line-height: 1.6;
                }
                .footer {
                    text-align: center;
                    margin-top: 25px;
                    padding-top: 15px;
                    border-top: 2px solid #f2f2f2;
                    color: #777;
                    font-size: 14px;
                }
            </style>
        </head>
        <body>
            <div class="container">
                <div class="header">
                    <img src="https://conga.com/themes/custom/themekit/images/branding/logo-conga-2022.svg" alt="Conga Logo">
                    <h2>CloudOps Weekly Infra Maintenance and Reboot Activity</h2>
                </div>
                
                <div class="content">
                    <div class="section">
                        <h3>What is this about?</h3>
                        <p>This activity will apply patches exclusively to the Turbo Database Cluster. No other systems will be affected during this process.</p>
                        ${
                          data.additionalOperations
                            ? `
                        <div class="additional-operations">
                            <h4>🔔 Additional Maintenance Operations</h4>
                            <div class="additional-operations-content">
                                ${data.additionalOperations}
                            </div>
                        </div>`
                            : ''
                        }
                    </div>
                    
                    <div class="section">
                        <h3>When is this scheduled?</h3>
                        <div class="schedule">
                            <p>This is planned to be performed on <strong>${
                              data.date || '22 June 2025'
                            }</strong>, ${data.day || 'Sunday'} <strong>${
      data.startTime || '10AM'
    }</strong> to ${
      data.endDate && data.endDate !== data.date
        ? `<strong>${data.endDate || '22 June 2025'}</strong>, `
        : ''
    }<strong>${data.endTime || '2PM'} ${data.timezone || 'IST'}</strong>.</p>
                        </div>
                    </div>
                    
                    <div class="section">
                        <h3>What is the service impact?</h3>
                        <p>Please refer to the below tenants and their impact during this maintenance.</p>
                        
                        <div class="tenant-list">
                            ${
                              data.tenantEnvironments
                                ? data.tenantEnvironments
                                    .map(
                                      (env) => `
                                    <div class="tenant">
                                        <h4>${env.name}</h4>
                                        <div class="tenant-names">
                                            ${env.tenants.trim()}
                                        </div>
                                        <div class="impact">Service Impact: ${
                                          env.impact ||
                                          'Intermittent Interruptions'
                                        }</div>
                                    </div>
                                `
                                    )
                                    .join('')
                                : `
                                    <div class="tenant">
                                        <h4>Sedemo1-aws</h4>
                                        <div class="tenant-names">
                                            sed28-henrik-v, sed4-cpqemea-v, sed25-rochediag, sed51-sophiemv2311, sed49-merck, sed71-schuler, sed75-boschv2410, sed78-abbv2321, sed83-cocacola, sed84-ngv2410, sed91-technogym, sed92-meggittv
                                        </div>
                                        <div class="impact">Service Impact: Intermittent Interruptions</div>
                                    </div>
                                    
                                    <div class="tenant">
                                        <h4>Sedemo4</h4>
                                        <div class="tenant-names">
                                            sed18-eogan, sed31-kirk, sed38-nick2220, sed40-gartner, sed54-congapartnersv2231, sed16-andres, sed43-scott, sed24-charles, sed37-hitachi, sed5-cpqna, sed30-grant, sed1-cpqmdo, sed19-bob, sed58-gartnered, sed59-medtronicls, sed60-acctls, sed62-billingplatform, sed65-airwallexv2320, sed68-diverzify, sed70-sko, sed74-ericv2410, sed77-hls, sed79-qantas, sed80-figma, sed82-jeffhls, sed85-acc2231, sed87-kms, sed88-accfull, sed89-spark, sed90-agl, sed94-startix
                                        </div>
                                        <div class="impact">Service Impact: Intermittent Interruptions</div>
                                    </div>
                                `
                            }
                        </div>
                    </div>
                    
                    <div class="section">
                        <h3>Where can I get help?</h3>
                        <div class="help-section">
                            <p>Please reach out to <a href="mailto:Cloud-Ops-All-DL@conga.com">Cloud-Ops-All-DL@conga.com</a> in case of any questions or query.</p>
                        </div>
                    </div>
                </div>
                
                <div class="footer">
                    <p>&copy; ${new Date().getFullYear()} Conga. All rights reserved.</p>
                </div>
            </div>
        </body>
        </html>
    `
  };
};

export default {
  requestAccessControlConfirmation,
  modifyAccessControlConfirmation,
  requestAccessControlNotificationToCloudopsTeam,
  notifyCloudopsTeamForModifiedRequest,
  appliedAccessControlNotificationToUser,
  rejectedAccessControlNotificationToUser,
  accessControlModifiedNotificationToUser,
  reminderToUsePlatformOrg,
  xAuthorUpdateNotification,
  cpqTrustedUrlsUpdateNotification,
  guestUserIdUpdateNotification,
  notifyApproversForChangeRequest,
  notifyRequesterChangeApproved,
  notifyRequesterChangeRejected,
  salesforceUserIdConflictNotification,
  samlAppsUpdateNotification,
  samlAppsUserAssignmentNotification,
  mongoDBWeeklyMaintenanceNotification
};
